import Cell from "./Cell";

const Matriz = (props) => {

    return props.row.cells.map((cell) => {
        const isRow = props.hovered.row === props.row.Id;
        const isCol = props.hovered.col === cell.actionId;
        const isBoth = isRow && isCol;
        return (
            <div
                key={`${cell.moduleId}-${cell.actionId}`}
                onMouseEnter={() => props.setHovered({ row: props.row.Id, col: cell.actionId })}
                onMouseLeave={() => props.setHovered({ row: null, col: null })}
                className={`
                    flex aspect-square items-center justify-center
                    border-b border-r border-gray-200 text-xs transition
                    ${isBoth ? 'bg-gray-200' : isRow || isCol ? 'bg-gray-100' : 'bg-white'}
                `}
            >
                <Cell
                    permissions={props.permissions(cell.moduleId, cell.actionId)}
                    actionName={cell.actionName}
                    isEditor={props.isEditor}
                    permissionsRoles={props.permissionsRoles}
                    setPermissionsSave={props.setPermissionsSave}
                />
            </div>
        );
    });
};

export default Matriz;
